module.exports = __webpack_public_path__ + "static/media/car.1bbfc5c5.png";